
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './calendar-date.twig';
import seasonsDemo from './demo/seasons.twig';
import './demo/styles.scss';
const argTypes = {
  datetime: {
    control: { type: 'date' },
  },
  note: { type: { name: 'string' } },
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Calendar Date" mdxType="Meta" />
    <h1>{`Calendar Date`}</h1>
    <p>{`Formats a `}<inlineCode parentName="p">{`<time>`}</inlineCode>{` element so that it looks like a calendar icon. Intended to accompany upcoming presentations and events.`}</p>
    <p>{`A short note may be included, for example the event length ("3-day event"), type ("teleconference") or sales status ("sold out").`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic" args={{
        datetime: Date.now()
      }} argTypes={argTypes} mdxType="Story">
    {({
          datetime,
          note
        }) => template({
          datetime: new Date(datetime),
          note
        })}
  </Story>
  <Story name="With Note" argTypes={argTypes} args={{
        datetime: Date.now(),
        note: '3-day event'
      }} mdxType="Story">
    {({
          datetime,
          note
        }) => template({
          datetime: new Date(datetime),
          note
        })}
  </Story>
    </Canvas>
    <h2>{`Seasons`}</h2>
    <p>{`To add some fun and visual variety, each season has its own header color. These are applied using a modifier class based on the month, for example `}<inlineCode parentName="p">{`c-calendar-date--january`}</inlineCode>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Seasons" parameters={{
        docs: {
          source: {
            code: `{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-04-01'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-07-04'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-10-31'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-12-31'
} only %}`
          }
        }
      }} mdxType="Story">
    {seasonsDemo()}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`datetime`}</inlineCode>{` (string): The display date. (e.g. `}<inlineCode parentName="li">{`'2020-04-01'`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{` (string): Append a class to the root element.`}</li>
    </ul>
    <h2>{`Template Blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`note`}</inlineCode>{`: A short note. (e.g. '3-day event')`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basic = (({
  datetime,
  note
}) => template({
  datetime: new Date(datetime),
  note
}));
basic.storyName = 'Basic';
basic.argTypes = argTypes;
basic.args = {
  datetime: Date.now()
};
basic.parameters = { storySource: { source: '({\n  datetime,\n  note\n}) => template({\n  datetime: new Date(datetime),\n  note\n})' } };

export const withNote = (({
  datetime,
  note
}) => template({
  datetime: new Date(datetime),
  note
}));
withNote.storyName = 'With Note';
withNote.argTypes = argTypes;
withNote.args = {
  datetime: Date.now(),
  note: '3-day event'
};
withNote.parameters = { storySource: { source: '({\n  datetime,\n  note\n}) => template({\n  datetime: new Date(datetime),\n  note\n})' } };

export const seasons = () => (
          seasonsDemo()
        );
seasons.storyName = 'Seasons';
seasons.parameters = { storySource: { source: 'seasonsDemo()' }, ...{
  docs: {
    source: {
      code: `{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-04-01'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-07-04'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-10-31'
} only %}
{% include '@cloudfour/components/calendar-date/calendar-date.twig' with {
  datetime: '2020-12-31'
} only %}`
    }
  }
} };

const componentMeta = { title: 'Components/Calendar Date', includeStories: ["basic","withNote","seasons"],  };

const mdxStoryNameToKey = {"Basic":"basic","With Note":"withNote","Seasons":"seasons"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;